import moment from 'moment';
import ticketAvailabilityInfo from '../components/ticket-picker/ticketAvailabilityInfo';

export const isTicketLongExpired = (ticket, startTime, months = 3) => {
    const info = ticketAvailabilityInfo(ticket, startTime);

    if (!info.expired || !ticket?.date_to) {
        return false;
    }

    return moment(startTime).diff(moment(ticket.date_to), 'months') > months;
};

export const shouldShowTicketInModal = ({
    ticket,
    role,
    startTime,
    hideUnavailable,
    showLongExpired
}) => {
    const info = ticketAvailabilityInfo(ticket, startTime);

    const isAgent = role === 'agent';
    const isExpired = info.expired;
    const isAvailable = info.available;
    const isLongExpired = isTicketLongExpired(ticket, startTime, 3);

    if (!isAgent) {
        return isAvailable;
    }

    if (isAvailable) {
        return true;
    }

    if (!isExpired) {
        return !hideUnavailable;
    }

    if (hideUnavailable) {
        return false;
    }

    if (isLongExpired) {
        return showLongExpired;
    }

    return true;
};

export const ticketOverlapsDateRange = (ticket, startDate, endDate) => {
    const dateFrom = moment(ticket.date_from, 'YYYY-MM-DD');
    const dateTo = moment(ticket.date_to, 'YYYY-MM-DD');

    if (startDate && dateTo.isBefore(startDate, 'day')) {
        return false;
    }

    if (endDate && dateFrom.isAfter(endDate, 'day')) {
        return false;
    }

    return true;
};

export const filterTicketsBySellingRange = (tickets = [], startDate, endDate) =>
    tickets.filter(ticket => ticketOverlapsDateRange(ticket, startDate, endDate));
